export default __webpack_public_path__ + "static/media/img-0085-japan-half-face.fe8e510f.png";